import { render, staticRenderFns } from "./categories-puzzle.vue?vue&type=template&id=4271dd0e&"
import script from "./categories-puzzle.vue?vue&type=script&lang=js&"
export * from "./categories-puzzle.vue?vue&type=script&lang=js&"
import style0 from "./categories-puzzle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports